<template>
  <div class="my-audit-history-orders-container">
    <ds-page-header :title="$t('myAuditHistoryOrders.page.title')" :subtitle="$t('myAuditHistoryOrders.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('myAuditHistoryOrders.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="_queryHistory">
          {{ $t('myAuditHistoryOrders.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :total="auditOrderHistorysInfo.total" :density="density" :show-column-setting="false" :show-refresh="true"
        @update:density="density = $event" @refresh="_queryHistory">
        <template #left><span class="ds-panel__title">{{ $t('myAuditHistoryOrders.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="auditOrderHistorysInfo.auditOrderHistorys" :loading="loading" :error="hasError"
        :error-message="errorMessage" :density="density" border
        :empty-description="$t('myAuditHistoryOrders.page.empty')" @retry="_queryHistory">
        <el-table-column prop="applyOrderId" :label="$t('myAuditHistoryOrders.orderNumber')" align="center" min-width="140">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.applyOrderId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="resOrderTypeName" :label="$t('myAuditHistoryOrders.orderType')" align="center" min-width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="info" :label="scope.row.resOrderTypeName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('myAuditHistoryOrders.orderStatus')" align="center" width="110">
          <template slot-scope="scope"><ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" /></template>
        </el-table-column>
        <el-table-column prop="userName" :label="$t('myAuditHistoryOrders.applicant')" align="center" min-width="100" />
        <el-table-column prop="createTime" :label="$t('myAuditHistoryOrders.createTime')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('myAuditHistoryOrders.operation')" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="_openDetailPurchaseApplyModel(scope.row)">{{ $t('myAuditHistoryOrders.view') }}</el-button>
          </template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="currentPage" :size="pageSize" :total="auditOrderHistorysInfo.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listAuditHistoryOrders } from '@/api/resource/myAuditHistoryOrdersApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'MyAuditHistoryOrdersList',
  components: { DsPageHeader, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      currentPage: 1,
      pageSize: 10,
      auditOrderHistorysInfo: {
        auditOrderHistorys: [],
        total: 0,
        conditions: {
          userName: '',
          auditLink: ''
        }
      }
    }
  },
  created() {
    this._listAuditOrderHistorys(this.currentPage, this.pageSize)
  },
  methods: {
    async _listAuditOrderHistorys(page, size) {
      try {
        this.loading = true
        this.hasError = false
        const params = {
          page: page,
          row: size,
          ...this.auditOrderHistorysInfo.conditions
        }
        const { data, total } = await listAuditHistoryOrders(params)
        this.auditOrderHistorysInfo.auditOrderHistorys = data
        this.auditOrderHistorysInfo.total = total
      } catch (error) {
        console.error('获取审核历史订单失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    _queryHistory() {
      this.currentPage = 1
      this._listAuditOrderHistorys(this.currentPage, this.pageSize)
    },
    _openDetailPurchaseApplyModel(purchaseApply) {
      this.$router.push({
        path: '/pages/common/purchaseApplyDetail',
        query: {
          applyOrderId: purchaseApply.applyOrderId,
          resOrderType: purchaseApply.resOrderType
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listAuditOrderHistorys(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAuditOrderHistorys(this.currentPage, this.pageSize)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-audit-history-orders-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
